import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

export interface UnipileSyncReport {
  unipileAccountId: string
  service: string
  fetched: number
  created: number
  skippedExisting: number
  skippedUnusable: number
  skippedFiltered?: number
  planLimitReached: boolean
  error: string | null
}

interface UnipileSyncResponse {
  reports: UnipileSyncReport[]
}

const syncContacts = async (params?: { sectorFilter?: string }): Promise<UnipileSyncResponse> => {
  const { data } = await api.post<UnipileSyncResponse>(
    '/ft_unipile/sync-contacts',
    params?.sectorFilter ? { sectorFilter: params.sectorFilter } : {},
  )
  return data
}

export const useUnipileSyncContacts = () => {
  const queryClient = useQueryClient()

  return useMutation<UnipileSyncResponse, Error, { sectorFilter?: string } | undefined>({
    mutationFn: syncContacts,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['contacts'] })
      await queryClient.invalidateQueries({ queryKey: ['ft_unipile_accounts'] })
    },
  })
}
